import http from "./http";

export const GetTenant = async () => await http.get("/");
export const AppLog = async data => await http.post('/log', data)